import { Injectable } from '@angular/core';
import { AppTheme, StorageKey } from 'src/app/shared/constants/global-config.constant';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(
    private commonService: CommonService
  ) { }

  /**
   * Resolves the active theme for this device from the `branch_theme_map` global config.
   *
   * Every failure path returns AppTheme.DEFAULT — missing config, malformed JSON,
   * unknown branch code, no branch code. A bad config edit can never break a branch.
   */
  getTheme(): string {
    try {
      const themeMap = this.commonService.getConfigBranchThemeMap();
      const branchCode = localStorage.getItem(StorageKey.BRANCH_CODE);

      if (!themeMap || !branchCode) {
        return AppTheme.DEFAULT;
      }

      // Exact match, not substring. The existing config flags use .includes(), which makes
      // 'SC1' match 'SC10' — do not inherit that bug here.
      const matchedTheme = Object.keys(themeMap).find(
        themeName => (themeMap[themeName] ?? []).some(code => code === branchCode)
      );

      return matchedTheme ?? AppTheme.DEFAULT;
    }
    catch {
      return AppTheme.DEFAULT;
    }
  }

  /**
   * Stamps the resolved theme onto <html> so global stylesheets can reach surfaces that
   * escape component scope — Ngb modal windows, SweetAlert2 popups and the fixed-position
   * custom keyboard all project to <body>, not into a component's shadow scope.
   */
  applyThemeToDocument() {
    document.documentElement.dataset.theme = this.getTheme();
  }

}
